<template>
  <div>
    <b-row v-if="catalogError">
      <b-col>
        <b-alert
          show
          variant="danger"
          class="text-center"
          style="padding: 15px"
        >
          {{ catalogError }}
        </b-alert>
      </b-col>
    </b-row>

    <b-row class="itens-container">
      <b-col
        v-for="product in catalog"
        :key="`${product.kit ? 'kit' : 'product'}-${product.id}`"
        md="3"
        class="mb-2"
      >
        <item-card :product="product" />
      </b-col>

      <b-col
        v-if="catalogLoading"
        md="12"
        class="p-3 text-center"
      >
        <b-spinner
          variant="success"
          label="Spinning"
          class="mr-1"
        />
      </b-col>

      <b-col
        v-if="paging.allRowsLoaded"
        md="12"
        class="p-3 text-center"
      >
        Todos os nossos produtos já foram carregados
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BAlert, BSpinner } from 'bootstrap-vue'
import { mapState } from 'vuex'
import ItemCard from '../cards/ItemCard.vue'

export default {
  components: {
    ItemCard,
    BRow,
    BCol,
    BAlert,
    BSpinner,
  },

  data() {
    return {}
  },

  computed: {
    ...mapState('pages/pdv/atm/catalog', ['catalog', 'catalogLoading', 'paging', 'catalogError']),
  },

  methods: {},
}
</script>

<style lang="scss">
.itens-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
</style>
